var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgContentful = function SvgContentful(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg_icon_contentful__svg4",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_icon_contentful__g4",
    transform: "matrix(.08299 0 0 .08299 1.43 .07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_contentful__path1",
    fill: "#fae501",
    d: "M87.333 200.777c-15.306-14.406-24.309-34.213-24.309-56.722s9.003-42.316 23.409-56.722c12.605-12.604 12.605-32.412 0-45.017s-32.412-12.605-45.017 0C16.206 68.426 0 104.44 0 144.055s16.206 75.629 42.316 101.739c12.605 12.605 32.413 12.605 45.017 0 11.705-12.605 11.705-32.413 0-45.017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_contentful__path2",
    fill: "#4fb5e1",
    d: "M87.333 87.333c14.406-15.306 34.213-24.309 56.722-24.309s42.316 9.003 56.722 23.409c12.604 12.605 32.412 12.605 45.017 0s12.605-32.412 0-45.017C219.684 16.206 183.67 0 144.054 0 104.44 0 68.427 16.206 42.317 42.316c-12.605 12.605-12.605 32.413 0 45.017 12.605 11.705 32.413 11.705 45.017 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_contentful__path3",
    fill: "#f05751",
    d: "M200.777 200.777c-14.406 15.305-34.213 24.309-56.722 24.309s-42.316-9.004-56.722-23.41c-12.604-12.604-32.412-12.604-45.017 0-12.605 12.606-12.605 32.413 0 45.018 26.11 25.21 62.124 41.416 101.739 41.416s75.629-16.206 101.739-42.316c12.605-12.605 12.605-32.413 0-45.017-12.605-11.705-32.413-11.705-45.017 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_icon_contentful__ellipse3",
    cx: 64.825,
    cy: 64.825,
    r: 31.512,
    fill: "#0681b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_icon_contentful__ellipse4",
    cx: 64.825,
    cy: 223.285,
    r: 31.512,
    fill: "#cd4739"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContentful);
export { ForwardRef as ReactComponent };